<div class="onboarding-panel" data-testid="por-cp-admin-onboarding-section">
    @if (isProduction) {
    <div class="production-warning" data-testid="por-cp-admin-prod-warning">
        <span>⚠️ WARNING: Production environment. Verify the organization before onboarding.</span>
    </div>
    } @if (onboardingState() !== 'success') {
    <p class="onboarding-description" data-testid="por-cp-admin-onboarding-message">This organization is not yet onboarded to Consumer Portal.</p>
    } @if (!showCredentialPrompt() && onboardingState() !== 'success') {
    <por-base-button [featureName]="'onboardConsumerPortal'" [disabled]="onboardingState() === 'loading'" (onclick)="onOnboardClick()" data-testid="por-cp-admin-onboard-button">
        @if (onboardingState() === 'loading') {
        <span porIcon icon="spinner"></span>
        } @if (onboardingState() !== 'loading') {
        <span>Setup/On-board Consumer Portal for {{ orgId }}</span>
        }
    </por-base-button>
    } @if (showCredentialPrompt()) {
    <div class="credential-prompt" data-testid="por-cp-admin-credential-prompt">
        <p class="credential-prompt__message">Some required credentials were not found in the configuration or browser storage. Please enter the missing values to proceed with onboarding.</p>

        @if (promptNeedsCognitoToken()) {
        <div class="credential-field">
            <label for="prompt-cognito-token">Cognito ID Token</label>
            <input
                id="prompt-cognito-token"
                type="password"
                [ngModel]="promptCognitoToken()"
                (ngModelChange)="promptCognitoToken.set($event)"
                placeholder="Paste your Cognito idToken here"
                data-testid="por-cp-admin-prompt-cognito-token" />
        </div>
        } @if (promptNeedsRelationshipId()) {
        <div class="credential-field">
            <label for="prompt-relationship-id">Relationship ID</label>
            <input
                id="prompt-relationship-id"
                type="text"
                [ngModel]="promptRelationshipId()"
                (ngModelChange)="promptRelationshipId.set($event)"
                placeholder="e.g. 39500 (prod) or 62701 (dev)"
                data-testid="por-cp-admin-prompt-relationship-id" />
        </div>
        }

        <div class="credential-actions">
            <por-base-button
                [featureName]="'onboardConsumerPortalSubmitCredentials'"
                [disabled]="onboardingState() === 'loading' || (promptNeedsCognitoToken() && !promptCognitoToken()) || (promptNeedsRelationshipId() && !promptRelationshipId())"
                (onclick)="onCredentialPromptSubmit()"
                data-testid="por-cp-admin-prompt-submit">
                <span>Continue with Onboarding</span>
            </por-base-button>
            <por-base-button [featureName]="'onboardConsumerPortalCancelCredentials'" (onclick)="onCredentialPromptCancel()" data-testid="por-cp-admin-prompt-cancel">
                <span>Cancel</span>
            </por-base-button>
        </div>
    </div>
    } @if (onboardingState() === 'success') {
    <div class="onboarding-success" data-testid="por-cp-admin-onboarding-success">
        <span class="success-icon">✓</span>
        <p>{{ successMessage() }}</p>
    </div>
    } @if (onboardingState() === 'error') {
    <div class="onboarding-error" data-testid="por-cp-admin-onboarding-error">
        <span class="error-icon">✗</span>
        <p>{{ errorMessage() }}</p>
    </div>
    }
</div>
